(function () {
  'use strict';

  var STORAGE_KEY = 'trypooh_popup_shown';
  var DELAY_MS = 5000;
  var CLOSE_MS = 200;
  var SUCCESS_AUTOCLOSE_MS = 3000;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init() {
    var popup = document.querySelector('[data-custom-popup]');
    if (!popup) return;

    var overlayCloseEls = popup.querySelectorAll('[data-popup-close]');
    var modal = popup.querySelector('.custom-popup__modal');
    var closeBtn = popup.querySelector('.custom-popup__close');
    var input = popup.querySelector('[data-popup-input]');
    var submit = popup.querySelector('[data-popup-submit]');
    var form = popup.querySelector('.custom-popup__form');
    var content = popup.querySelector('[data-popup-content]');
    var success = popup.querySelector('[data-popup-success]');
    var errorEl = popup.querySelector('[data-popup-error]');

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var previousBodyOverflow = '';
    var previousFocus = null;
    var autoCloseTimer = null;

    function focusables() {
      var list = [];
      if (closeBtn) list.push(closeBtn);
      if (input && !input.disabled && content && !content.hasAttribute('hidden')) list.push(input);
      if (submit && !submit.disabled && content && !content.hasAttribute('hidden')) list.push(submit);
      return list;
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;

      var items = focusables();
      if (items.length === 0) return;

      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;

      if (e.shiftKey) {
        if (active === first || !popup.contains(active)) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (active === last || !popup.contains(active)) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function markShown() {
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* ignore */ }
    }

    function open(asSuccess) {
      if (!popup.hasAttribute('hidden') && popup.classList.contains('is-open')) return;
      markShown();
      previousFocus = document.activeElement;
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      popup.removeAttribute('hidden');
      // Force reflow so the transition runs.
      void popup.offsetWidth;
      popup.classList.add('is-open');
      document.addEventListener('keydown', onKeydown);
      setTimeout(function () {
        if (asSuccess) {
          if (closeBtn) closeBtn.focus();
        } else if (input) {
          input.focus();
        }
      }, reducedMotion ? 0 : 100);
    }

    function finalizeClose() {
      popup.classList.remove('is-open', 'is-closing');
      popup.setAttribute('hidden', '');
      document.body.style.overflow = previousBodyOverflow;
      document.removeEventListener('keydown', onKeydown);
      if (previousFocus && typeof previousFocus.focus === 'function') {
        try { previousFocus.focus(); } catch (e) { /* ignore */ }
      }
    }

    function close() {
      if (popup.hasAttribute('hidden')) return;
      markShown();
      if (autoCloseTimer) {
        clearTimeout(autoCloseTimer);
        autoCloseTimer = null;
      }
      if (reducedMotion) {
        finalizeClose();
        return;
      }
      popup.classList.remove('is-open');
      popup.classList.add('is-closing');
      setTimeout(finalizeClose, CLOSE_MS);
    }

    function showError() {
      if (!errorEl) return;
      errorEl.hidden = false;
      if (input) input.setAttribute('aria-invalid', 'true');
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      if (input) input.removeAttribute('aria-invalid');
    }

    function showSuccess() {
      if (content) content.hidden = true;
      if (success) success.hidden = false;
      autoCloseTimer = setTimeout(close, SUCCESS_AUTOCLOSE_MS);
    }

    function onSubmit(e) {
      if (!input) return;
      var value = (input.value || '').trim();
      if (!EMAIL_RE.test(value)) {
        e.preventDefault();
        showError();
        input.focus();
        return;
      }
      hideError();
      // Let the form submit naturally — Shopify will redirect back with ?popup_success=1
    }

    for (var i = 0; i < overlayCloseEls.length; i++) {
      overlayCloseEls[i].addEventListener('click', close);
    }
    if (form) form.addEventListener('submit', onSubmit);
    if (input) input.addEventListener('input', hideError);

    var isSuccessReturn = false;
    try {
      isSuccessReturn = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
    } catch (e) { /* ignore */ }

    if (isSuccessReturn) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        history.replaceState(null, '', url.pathname + url.search);
      } catch (e) { /* ignore */ }
      markShown();
      open(true);
      showSuccess();
      return;
    }

    try {
      if (sessionStorage.getItem(STORAGE_KEY)) return;
    } catch (e) { /* sessionStorage blocked — fall through and show popup */ }

    setTimeout(open, DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
